import React, { useEffect, useRef } from 'react'
import { batch, useDispatch } from 'react-redux'
import { useIsPageVisible } from '../hooks'
import { useSettings, setSettings } from '../slices/settings'
import { addMessage } from '../slices/ui'

const WakeLockManager = (props) => {

  const dispatch = useDispatch()
  const wakeLock = useRef(null)
  const { wakelock:isActive } = useSettings()
  const isPageVisible = useIsPageVisible()

  useEffect(()=>{

    if (!(wakeLock in navigator)) return null

    if (!isActive || !isPageVisible) {
      if (!wakeLock.current) return
      instance.current.release().then(() => {
          wakeLock.current = null
      })      
    } else {
      try {
        navigator.wakeLock.request("screen").then(()=>{
          wakeLock.current=this
        })
      } catch (err) {
        batch(()=>{
          dispatch(addMessage({
              message: `${err.name}, ${err.message}`,
              status: 'error',
              timeout: 4000
          }))
          dispatch(setSettings({wakelock: false}))
        })
      }
    }
  }, [isActive, isPageVisible, dispatch])  

  return null
}

export default WakeLockManager
